import { i18n } from '@/i18n'
// import store from '@/store'

export default (params) => {
  return [
    {
      icon: 'config',
      name: i18n.t('webhooks.header'),
      path: 'configurations/webhooks',
      use_parent_params: true,
      // params_required: ['id'],
      registerNavFromMenu: true,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'configurations/webhooks/detail',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('historical.entity_name'),
          path: 'configurations/webhooks/historical',
          params,
          registerNavFromMenu: false,
          disabled: params.idWebHook === -1 || params.idWebHook === '-1',
          sc: [] // shorcuts
        },
      ]
    }
  ]
}
